module.exports = __webpack_public_path__ + "static/media/organization-office-building-profile.6d7d4775.svg";